import { render, staticRenderFns } from "./RedirectByRdv.vue?vue&type=template&id=3683d6e1&"
import script from "./RedirectByRdv.vue?vue&type=script&lang=js&"
export * from "./RedirectByRdv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports